export enum PremiumModalNames {
  automatedBreaks = 'automatedBreaks',
  breaksAttestation = 'breaksAttestation',
  bulkMessages = 'bulkMessages',
  clockIn = 'clockIn',
  clopening = 'clopening',
  conversationRestrictions = 'conversationRestrictions',
  enableMessages = 'enableMessages',
  enableNewsfeed = 'enableNewsfeed',
  enableTasks = 'enableTasks',
  freeUserLimit = 'freeUserLimit',
  googleCalendarSync = 'googleCalendarSync',
  groupMessages = 'groupMessages',
  kiosk = 'kiosk',
  laborCompliance = 'laborCompliance',
  projectedSalesSync = 'projectedSalesSync',
  lateArrival = 'lateArrival',
  managerScheduleVisibility = 'managerScheduleVisibility',
  messages = 'messages',
  paidTimeOffs = 'paidTimeOffs',
  shiftAcceptance = 'shiftAcceptance',
  shiftAppearance = 'shiftAppearance',
  shiftFeedback = 'shiftFeedback',
  shiftSwap = 'shiftSwap',
  shiftTasks = 'shiftTasks',
  smsAlarms = 'smsAlarms',
  unavailability = 'unavailability',
  unavailabilityApproval = 'unavailabilityApproval',
  userDocuments = 'userDocuments',
  usersCanSeeUsersOutsideLocation = 'usersCanSeeUsersOutsideLocation',
}
